import React, { useCallback, useMemo } from "react";
import { Box, Checkbox, FormControlLabel, FormGroup, styled, Typography, useMediaQuery, useTheme } from "@mui/material";
import { TypeSollicitation } from "../../../core/apis/monsisra/generated";
import { useAppDispatch, useAppSelector } from "../../store";
import { setPreferencesPartial } from "../../store/expertise/expertise.reducer";
import { TypeSollicitationCtx } from "../../../index";

const strings = (type: TypeSollicitation) => ({
	btn:
		type === TypeSollicitation.TeleExpertise
			? "Je souhaite apparaître dans l'annuaire régional des experts."
			: "Je souhaite apparaître dans l'annuaire régional des équipes ressources.",
});


const Title = styled('div')(({ theme }) => ({
	...theme.typography.button,
	backgroundColor: theme.palette.background.paper,
	fontWeight: "bold",
	fontSize: "20px",
	color: "#B6AC42",
}));

export default function ApparaitreAnnuaire() {
	const typeSollicitation = React.useContext(TypeSollicitationCtx);
	const str = useMemo(() => strings(typeSollicitation), [typeSollicitation]);

	const dispatch = useAppDispatch();

	const { preferences } = useAppSelector((s) => s.expertise);

	const toggle = useCallback(() => {
		dispatch(
			setPreferencesPartial({
				statutDansAnnuaire: !preferences?.statutDansAnnuaire,
			})
		);
	}, [dispatch, preferences]);



	const theme = useTheme();
	const isLargeScreen = useMediaQuery(theme.breakpoints.up("sm"))

	const title = useMemo(() => {
		return typeSollicitation === TypeSollicitation.TeleExpertise ? "Préférences d'expert" : "Préférences de l'équipe ressource";
	}, [typeSollicitation]);

	if (!preferences) return null;


	return (
		<Box className={"ApparaitreAnnuaire"} marginTop={typeSollicitation === TypeSollicitation.DemandeAppui ? "25px" : 0}>
		 <Title>{title}</Title>
			<FormGroup sx={{ marginLeft: isLargeScreen ? "60px" : "0" }}>
				<FormControlLabel
					control={<Checkbox onChange={toggle} checked={preferences.statutDansAnnuaire} id={'apparaitre-annuaire'}/>}
					label={
						<Typography color={"primary"} sx={{ fontWeight: "bold", fontStyle: "italic", fontSize: "150%" }}>
							{str.btn}
						</Typography>
					}
				/>
			</FormGroup>
		</Box>
	);
}
